module.exports = __webpack_public_path__ + "static/media/user-twitter.a2bb442b.svg";